var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import * as React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { Icon } from '@material-ui/core';
import * as classNames from 'classnames';
import { getTranslation } from '../../../translation';
var styles = function (theme) { return ({
    root: {
        width: '100%',
    },
    rootTrack: {
        background: '#fff',
        margin: '8px 0',
        // padding: '5px 10px 5px 15px',
        border: '1px solid #f3f3f3',
        fontSize: '1.3rem',
        overflow: 'hidden',
    },
    rowWrap: {
        position: 'relative',
    },
    verticalLine: {
        position: 'absolute',
        width: 1,
        background: '#b5b5b5',
        zIndex: 1,
        top: 20,
        bottom: 0,
    },
    horizontalLine: {
        position: 'absolute',
        right: 0,
        top: '50%',
        height: 1,
        background: '#b5b5b5',
    },
    circle: {
        border: '1px solid #b5b5b5',
        margin: '0 auto',
        fontSize: 10,
        fontWeight: 'bold',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    circleIcon: {
        background: '#ccc',
    },
    icon: {
        fontSize: 12,
        color: 'white',
        fontWeight: 'bold',
    },
    itemText: {
        padding: '12px 20px 12px 5px',
        '& a': {
            color: 'black!important',
        },
    },
    itemTextSelected: {
        '& a': {
            color: 'white!important',
        },
    },
    bottomLineEraser: {
        position: 'absolute',
        top: '50%',
        bottom: 0,
        width: 1,
        background: '#fff',
        marginTop: 1,
        zIndex: 1,
    },
    topLineEraser: {
        position: 'absolute',
        bottom: '50%',
        top: 0,
        width: 1,
        background: '#fff',
        marginBottom: 1,
        zIndex: 1,
    },
    lineEraserSelected: {
        background: 'none',
    },
}); };
var widthFactor = 26;
var rowHeight = 40;
var circleSize = 28;
var leftMargin = 20;
// @ts-ignore
var HelpTrackList = /** @class */ (function (_super) {
    __extends(HelpTrackList, _super);
    function HelpTrackList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            collapsed: _this.props.tracks.map(function (track) { return track.id; }),
        };
        _this.isCollapsed = function (id) { return _this.state.collapsed.indexOf(id) !== -1; };
        _this.handleTrackToggle = function (itemId) { return function (e) {
            if (_this.isCollapsed(itemId)) {
                _this.setState({
                    collapsed: _this.state.collapsed.filter(function (id) { return id !== itemId; }),
                });
            }
            else {
                _this.setState({
                    collapsed: __spreadArray(__spreadArray([], _this.state.collapsed), [itemId]),
                });
            }
            e.stopPropagation();
        }; };
        _this.getFilteredItems = function (items) {
            return items.filter(function (item) { return item.type === 'video' || Boolean(_this.getFilteredItems(item.items).length); });
        };
        _this.renderItems = function (items) {
            var _a = _this.props, classes = _a.classes, tubeColor = _a.tubeColor, videosWatched = _a.videosWatched;
            var filteredItems = _this.getFilteredItems(items);
            var videoIndex = 0;
            return filteredItems.map(function (item, index) {
                var isRoot = item.depth === 0;
                var isLast = index === filteredItems.length - 1;
                var isFirst = index === 0 || isRoot;
                var isSelected = item.id === _this.props.featuredVideoId;
                var hasNoChildren = item.type === 'video' || item.items.length === 0;
                var lastItemsChildren = item.type !== 'video' &&
                    !hasNoChildren &&
                    item.items[item.items.length - 1].items &&
                    _this.isCollapsed(item.items[item.items.length - 1].id)
                    ? item.items[item.items.length - 1].items.length
                    : 0;
                if (item.type === 'video') {
                    videoIndex += 1;
                }
                return (React.createElement("div", { key: item.id + "-" + index, className: classNames(isRoot && classes.rootTrack), style: isSelected
                        ? {
                            backgroundColor: tubeColor,
                            userSelect: 'none',
                        }
                        : { userSelect: 'none' } },
                    React.createElement("div", { id: "help-track-" + (item.name || item.id || '').replace(/\s{1,}/g, '-') + "-" + index + "-item", onClick: _this.handleTrackToggle(item.id), style: {
                            position: 'relative',
                            cursor: 'pointer',
                            display: _this.isCollapsed(item.parent) || item.depth === 0 ? 'block' : 'none',
                        } },
                        React.createElement("div", { className: classes.verticalLine, style: {
                                display: hasNoChildren || !_this.isCollapsed(item.id) ? 'none' : 'block',
                                left: item.depth * widthFactor + leftMargin,
                                height: "calc(100% - " + rowHeight * (1 + lastItemsChildren) + "px)",
                            } }),
                        React.createElement("table", { cellSpacing: 0, cellPadding: 0, style: {
                                height: rowHeight,
                            } },
                            React.createElement("tbody", null,
                                React.createElement("tr", null,
                                    React.createElement("td", null,
                                        React.createElement("div", { style: {
                                                position: 'relative',
                                                height: '100%',
                                                width: item.depth * widthFactor + leftMargin,
                                            } },
                                            React.createElement("div", { className: classes.horizontalLine, style: {
                                                    width: item.depth ? widthFactor : 0,
                                                } }),
                                            React.createElement("div", { className: classNames(classes.topLineEraser, isSelected && classes.lineEraserSelected), style: {
                                                    display: isFirst ? 'block' : 'none',
                                                    right: -1,
                                                } }),
                                            React.createElement("div", { className: classNames(classes.bottomLineEraser, isSelected && classes.lineEraserSelected), style: {
                                                    display: isLast && !isSelected ? 'block' : 'none',
                                                    right: widthFactor - 1,
                                                } }))),
                                    React.createElement("td", { style: { verticalAlign: 'middle', textAlign: 'center' } },
                                        React.createElement("div", { style: {
                                                width: widthFactor,
                                                marginLeft: -widthFactor / 2,
                                                marginRight: 5,
                                                position: 'relative',
                                                zIndex: 1,
                                            } },
                                            React.createElement("div", { className: classNames(classes.circle, item.type === 'track' && classes.circleIcon), style: {
                                                    background: item.type === 'track' ? '#ccc' : videosWatched[item.id] ? tubeColor : 'white',
                                                    color: videosWatched[item.id] ? 'white' : 'black',
                                                    width: circleSize,
                                                    height: circleSize,
                                                    borderRadius: circleSize,
                                                    lineHeight: circleSize + 'px',
                                                } }, item.type === 'track' ? (React.createElement(Icon, { className: classes.icon }, _this.isCollapsed(item.id) ? 'remove' : 'add')) : (videoIndex)))),
                                    React.createElement("td", null,
                                        React.createElement("div", { className: classNames(classes.itemText, isSelected && classes.itemTextSelected) }, item.type === 'video' ? (React.createElement("a", { id: "video-" + (item.name || item.id || '').replace(/\s{1,}/g, '-') + "-link", target: "_blank", style: { color: tubeColor }, href: "/video/" + item.humanId, onClick: _this.props.onClose }, item.name)) : (item.name)))))),
                        item.items && _this.renderItems(item.items))));
            });
        };
        return _this;
    }
    HelpTrackList.prototype.render = function () {
        var _a = this.props, classes = _a.classes, translate = _a.translate;
        return (React.createElement("div", { className: classes.root },
            this.props.featuredVideoId && React.createElement("h3", null, translate('help-dialog-title')),
            this.renderItems(this.props.tracks)));
    };
    HelpTrackList = __decorate([
        withStyles(styles, { withTheme: true })
    ], HelpTrackList);
    return HelpTrackList;
}(React.PureComponent));
export default connect(function (state, ownProps) { return (__assign(__assign({}, ownProps), { user: state.auth.user, readVideo: Boolean(state.auth.user.permissions) && Boolean(state.auth.user.permissions.readVideo), translate: getTranslation(state.translation.lang), lang: state.translation.lang, tubeColor: state.auth.tube.color })); })(HelpTrackList);



//////////////////
// WEBPACK FOOTER
// ./src/components/layouts/Main/HelpTrackList.tsx
// module id = 2033
// module chunks = 81